// src/data/box3Answers.js
//
// SECTION 510 (2026-09-29). BOX 3 ANSWERS WERE NEVER SAVED - FIXED.
//
// Found while building ruling 261 (task list section 509, item 4): Quick File's Box 3 ("Complete Your Claim") put each
// answer in the form bag under its question id (q_datetime, q_manager, q_seniority ...). None of those keys is in
// claimPayload's allow-list, so buildClaimPayload never wrote them: every Box 3 answer a member typed was lost on
// Save as Draft and on File Claim. Bob, 2026-09-29: "This is the most important area of the whole platform ...
// We have to fix the issue tonight, not tomorrow morning."
//
// THE FIX. The answers are saved as ONE field, `box3Answers`: a list of { id, q, answer } - the question AS THE
// MEMBER SAW IT beside his answer, so an officer reading the claim reads both. Only answered questions are listed.
// A resumed draft puts each answer back under its question id, so the member sees what he wrote.
// Pure module: no React, no Firestore.

const s = (v) => (v == null ? '' : String(v).trim());

// questions: [{ id, q }] as shown on screen. Returns [{ id, q, answer }] for every non-empty answer.
export function collectBox3Answers(bag, questions) {
  const b = bag || {};
  return (Array.isArray(questions) ? questions : [])
    .filter(x => x && x.id && s(b[x.id]) !== '')
    .map(x => ({ id: x.id, q: s(x.q), answer: s(b[x.id]) }));
}

// Back into the form bag on resume: { q_id: answer }.
export function box3AnswersToKeys(list) {
  const out = {};
  (Array.isArray(list) ? list : []).forEach(x => { if (x && /^q_[a-z_]+$/.test(String(x.id || '')) && s(x.answer)) out[x.id] = s(x.answer); });
  return out;
}
